type TokenGetter = () => Promise<string | undefined>;
type UserGetter = () =>
  | Promise<Record<string, unknown> | undefined | null>
  | Record<string, unknown>
  | undefined
  | null;
type LogoutHandler = () => Promise<void> | void;

let tokenGetter: TokenGetter | null = null;
let userGetter: UserGetter | null = null;
let logoutHandler: LogoutHandler | null = null;

export const registerTokenGetter = (getter: TokenGetter) => {
  tokenGetter = getter;
};

export const registerUserGetter = (getter: UserGetter) => {
  userGetter = getter;
};

export const registerLogoutHandler = (handler: LogoutHandler) => {
  logoutHandler = handler;
};

export const getAccessToken = async (): Promise<string | undefined> => {
  if (!tokenGetter) {
    return undefined;
  }

  return tokenGetter();
};

export const getUserInfo = async (): Promise<Record<string, unknown> | undefined | null> => {
  if (!userGetter) {
    return undefined;
  }

  return userGetter();
};

export const triggerLogout = async (): Promise<void> => {
  if (!logoutHandler) {
    return;
  }

  await logoutHandler();
};


